import controller from './upload-classic.controller';
import template from './upload-classic.html';
import './upload-classic.scss';

export default {
	controller,
	template,
	bindings: {
		form:      '<?',
		navClass:  '@?',
		onCancel:  '&?',
		onFinish:  '&?',
		onSubmit:  '&?',
		options:   '<?',
	},
};
